<div class="row">
  <div class="col-12 col-lg-10">
    <div class="mb-3">
      <label class="form-label" [for]="'socialSecurity_' + count">
        SSN
        <span *ngIf="controlIsRequired('SSN')" class="color-error">*</span>
      </label>
      <div
        [ngClass]="['form-control-show-password', getFormControl('SSN').invalid && getFormControl('SSN').touched ? 'ng-invalid' : '']"
        class="form-control-show-password">
        <input class="form-control no-border" [id]="'socialSecurity_' + count" placeholder="Social security number"
          [type]="showPassword ? 'text' : 'password'" [formControl]="getFormControl('SSN')"
          aria-label="Social security number" />
        <a class="type-toggle" (click)="toggleShowPassword()">
          <i [hidden]="showPassword" class="bi bi-eye-slash color-dark hide-option">
          </i>
          <i [hidden]="!showPassword" class="bi bi-eye color-dark hide-option">
          </i>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="mb-3">
      <div>
        <label class="form-label" [for]="'dobYear_' + count">
          Date of Birth
          <span
            *ngIf="controlIsRequired('DateOfBirthYear') && controlIsRequired('DateOfBirthMonth') && controlIsRequired('DateOfBirthDay')"
            class="color-error">*</span>
        </label>
      </div>
      <div class="row">
        <div class="col-4">
          <select class="form-select" [id]="'dobYear_' + count" [formControl]="getFormControl('DateOfBirthYear')"
            aria-label="Date of birth year">
            <option value="" disabled selected>Year</option>
            <option *ngFor="let year of years" [value]="year.value">
              {{ year.text }}
            </option>
          </select>
          <ng-container *ngIf="getFormControl('DateOfBirthYear').value">
            <div class="text-center color-medium date-sublabel-fields">YEAR</div>
          </ng-container>
        </div>
        <div class="col-4">
          <select class="form-select" [id]="'dobMonth_' + count" [formControl]="getFormControl('DateOfBirthMonth')"
            aria-label="Date of birth month">
            <option value="" disabled selected>Month</option>
            <option *ngFor="let month of months" [value]="month.value">
              {{ month.text }}
            </option>
          </select>
          <ng-container *ngIf="getFormControl('DateOfBirthMonth').value">
            <div class="text-center color-medium date-sublabel-fields">MONTH</div>
          </ng-container>
        </div>
        <div class="col-4">
          <select class="form-select" [id]="'dobDay_' + count" [formControl]="getFormControl('DateOfBirthDay')"
            aria-label="Date of birth day">
            <option value="" disabled selected>Day</option>
            <option *ngFor="let day of days" [value]="day.value">
              {{ day.text }}
            </option>
          </select>
          <ng-container *ngIf="getFormControl('DateOfBirthDay').value">
            <div class="text-center color-medium date-sublabel-fields">DAY</div>
          </ng-container>
        </div>
      </div>

      <input [id]="'dob_' + count" type="hidden" [formControl]="getFormControl('DateOfBirth')">
      <!-- <ngb-datepicker
        [id]="'dob_' + count"
        #dp
        [minDate]="{ year: 1930, month: 1, day: 1 }"
        [maxDate]="getMaxDateForDOBControl()"
        [formControl]="getFormControl('DateOfBirth')"
        [startDate]="getDOBFormControlValue('DateOfBirth')"
      ></ngb-datepicker> -->
    </div>
  </div>
</div>